// src/pages/suppliers/EditSupplier.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSupplier from "../../components/suppliers/FormAddEditSupplier";
import useGetSupplier from "../../hooks/suppliers/useGetSupplier";
import LoadingPage from "../../components/global/LoadingPage";

const EditSupplier = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, supplier } = useGetSupplier(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/suppliers");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSupplier
                isEdit={true}
                currentData={supplier}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditSupplier;
